import { SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

export function sanitizeHtml(sanitizer: DomSanitizer, html: string | null | undefined): string {
  const value = html ?? '';
  return sanitizer.sanitize(SecurityContext.HTML, value) ?? '';
}
